import { render, staticRenderFns } from "./DialogAddTaxe.vue?vue&type=template&id=267c3c38"
import script from "./DialogAddTaxe.vue?vue&type=script&lang=js"
export * from "./DialogAddTaxe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports